import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 602EE454-C61C-4608-919E-FCCF3B58DE65
 * name message-processing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-processing.svg
 * tags
 */
export const MessageProcessingIcon = createSvgIcon(<><path d="M17,11H15V9H17M13,11H11V9H13M9,11H7V9H9M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" /></>, 'MessageProcessingIcon');
export default MessageProcessingIcon